import { useHistory, Route } from 'react-router-dom';
import { Button, Card, Page, Typography } from 'seagull';
import { routes } from "../../constants";
import { useSetDocumentTitle } from "../../hooks/useSetDocumentTitle";
import { useIoContext } from "../../providers/IoContext";
import { ActiveServicesReport } from "./ActiveServices/ActiveServices";
import { FutureInvoicesReport } from "./FutureInvoices/FutureInvoices";
import { ProposalsReport } from "./ProposalsReport/ProposalsReport";
import { RemainingCreditReport } from "./RemainingCredit/RemainingCredit";
import styles from "./Reports.module.scss";
import { RevenueBreakdownReport } from "./RevenueBreakdown/RevenueBreakdown";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const ReportCard = props => {
  const {
    title,
    description,
    url,
    testId
  } = props;
  const history = useHistory();
  return /*#__PURE__*/_jsxs(Card, {
    className: styles.reportCard,
    autoHeight: true,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.reportCardDetails,
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "h6",
        weight: "bold",
        children: title
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "paragraph1",
        children: description
      })]
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Button, {
        testId: "report-card-".concat(testId, "-navigate"),
        onClick: () => history.push(routes.reports + url),
        children: "Go to report"
      })
    })]
  });
};
const AllReports = () => {
  useSetDocumentTitle('Reports');
  return /*#__PURE__*/_jsxs(Page, {
    header: "All Reports",
    testId: "all-reports-screen",
    children: [/*#__PURE__*/_jsx(ReportCard, {
      title: "Revenue Breakdown",
      description: "Review historical revenue with detailed breakdowns across various time intervals. This revenue data is based on paid invoices and accounts for any refunds and disputes, if applicable. Note that the revenue data does not include any platform fees.",
      url: "/revenue",
      testId: "revenue"
    }), /*#__PURE__*/_jsx(ReportCard, {
      title: "Active Services",
      description: "View all active services across all of your agreements with options to apply various filters.",
      url: "/active-services",
      testId: "active-services"
    }), /*#__PURE__*/_jsx(ReportCard, {
      title: "Future Invoices",
      description: "View all invoices scheduled for issuance over the next 12 months.",
      url: "/future-invoices",
      testId: "future-invoices"
    }), /*#__PURE__*/_jsx(ReportCard, {
      title: "Sent Proposals",
      description: "View all sent proposals by their sent date and current status.",
      url: "/sent-proposals",
      testId: "sent-proposals"
    }), /*#__PURE__*/_jsx(ReportCard, {
      title: "Remaining Credit",
      description: "View the remaining credit your clients have per agreement.",
      url: "/remaining-credit",
      testId: "remaining-credit"
    })]
  });
};
export const Reports = _ref => {
  let {
    now
  } = _ref;
  const {
    getNow
  } = useIoContext();
  const nowValue = now !== null && now !== void 0 ? now : getNow();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: routes.reports,
      exact: true,
      render: () => /*#__PURE__*/_jsx(AllReports, {})
    }, "all-reports"), /*#__PURE__*/_jsx(Route, {
      path: routes.revenueReport,
      exact: true,
      render: () => /*#__PURE__*/_jsx(RevenueBreakdownReport, {
        now: nowValue
      })
    }, "revenue-report"), /*#__PURE__*/_jsx(Route, {
      path: routes.activeServicesReport,
      exact: true,
      render: () => /*#__PURE__*/_jsx(ActiveServicesReport, {})
    }, "active-services-report"), /*#__PURE__*/_jsx(Route, {
      path: routes.futureInvoicesReport,
      exact: true,
      render: () => /*#__PURE__*/_jsx(FutureInvoicesReport, {})
    }, "future-invoices-report"), /*#__PURE__*/_jsx(Route, {
      path: routes.proposalsReport,
      exact: true,
      render: () => /*#__PURE__*/_jsx(ProposalsReport, {
        now: nowValue
      })
    }, "proposals-report"), /*#__PURE__*/_jsx(Route, {
      path: routes.remainingCreditReport,
      exact: true,
      render: () => /*#__PURE__*/_jsx(RemainingCreditReport, {})
    }, "remaining-credit-report")]
  });
};